"use strict";
var ko = require("knockout");
var $ = require("jquery");
var _ = require("lodash");
require("readmore");
ko.bindingHandlers["read-more"] = {
    init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        var $el = $(element), options = valueAccessor();
        var moreLinkText = options.moreLinkText || "показать все";
        var defaultOptions = {
            moreLink: "<a class=\"button btn-block rm-expand\" href=\"#\">" + moreLinkText + "</a>",
            lessLink: "<a class=\"button btn-block rm-collapse\" href=\"#\">свернуть</a>",
            embedCSS: false,
            collapsedHeight: 84
        };
        $el.readmore(_.defaults(options, defaultOptions));
    }
};
//# sourceMappingURL=ko.readMore.js.map